import { FeaturamaServiceClientImpl as r, BulkRetrieveFeatureSetStatusesRequest as s, BulkRetrieveFeatureStatusesRequest as o } from "../../../libs/shared/types-protos/dist/squareup/featurama/service.js";
import n from "../../utils/rpc.js";
const i = n(), u = new r(i), c = (a) => {
  const t = {};
  for (const e of a)
    e.key !== void 0 && (t[e.key] = e);
  return t;
}, S = (a) => {
  const t = {};
  for (const e of a)
    e.featureSetKey === void 0 || e.activationStatus === void 0 || (t[e.featureSetKey] = e.activationStatus);
  return t;
};
async function v(a) {
  const t = o.create(a), e = await u.bulkRetrieveFeatureStatuses(t);
  return c(e.featureStatuses);
}
async function l(a) {
  const t = s.create(a), e = await u.bulkRetrieveFeatureSetStatuses(t);
  return S(e.featureSetStatuses);
}
export {
  l as bulkRetrieveFeatureSetStatuses,
  u as featuramaClient,
  v as fetchFeaturamaFeatureStatuses
};
